import CoreDrawer from '@/components/CoreDrawer';
import { Spin } from 'antd';
import { get } from 'lodash';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import GetDetailCenter from '../../viewmodels/center-detail.viewmodel';
import { CenterForm } from './CenterForm';

interface Props {
  open: boolean;
  handleClose: () => void;
  setOpen: (value: boolean) => void;
}

export const DetailCenter = (props: Props) => {
  const { open, setOpen, handleClose } = props;
  const { loadingCenter, errorCenter, detailCenter, actionGetDetail } = GetDetailCenter();

  const [currentQueryParameters] = useSearchParams();
  const showId = currentQueryParameters.get('id');
  const getAction = currentQueryParameters.get('action');

  useEffect(() => {
    if ((showId !== null && getAction === 'Detail') || getAction === 'Create') {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [open, handleClose, setOpen]);

  useEffect(() => {
    if (showId) {
      actionGetDetail();
    }
  }, [open]);

  const renderContent = () => {
    return (
      <>
        <div>{loadingCenter && <Spin />}</div>
        {errorCenter && <div>Error</div>}
        {!errorCenter && !loadingCenter && (
          <CenterForm detailCenter={get(detailCenter, 'data')} openForm={open} />
        )}
      </>
    );
  };

  return (
    <CoreDrawer
      open={open}
      onClose={() => handleClose()}
      content={renderContent()}
      bodyStyle={{ marginTop: '20px' }}
    />
  );
};
